/* Same-tab cart handoff. Snapshot and exchange keys travel only in HTTPS JSON
 * and this origin's sessionStorage. Fragments contain opaque exchange material. */
(function (root, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root && root.document) root.NLLanguageSameTab = api.install(root);
})(typeof window === 'undefined' ? null : window, function () {
  'use strict';
  var BASE = 'https://jarvis.royceassistant.com/api/naturlabs/cart-relay/';
  var ORIGINS = ['https://naturlabs.cz', 'https://naturlabs.eu'], HEX = /^[a-f0-9]{64}$/;
  var SOURCE = 'nl-same-tab-source-v1:', ACTIVE = 'nl-same-tab-source-active-v1', INCOMING = 'nl-same-tab-incoming-v1';
  function path(value) {
    if (typeof value !== 'string' || value.length > 1024 || !value.startsWith('/') || value.startsWith('//') || /[?#\\\x00-\x20]/.test(value) || /\/(?:admin|account|checkout|checkouts)(?:\/|$)/i.test(value)) throw new Error('Unsupported basket destination');
    return value;
  }
  function targetURL(value, origin) {
    var url = new URL(value, origin);
    if (!ORIGINS.includes(url.origin) || url.origin === origin || url.search || url.hash || url.username || url.password) throw new Error('Unsupported basket destination');
    path(url.pathname); return url;
  }
  function original(raw) {
    // Explicit projection: never persist the raw Ajax token, customer fields,
    // cart identifiers, cookies, URLs, or unrelated provider metadata.
    return { currency: raw.currency, item_count: raw.item_count, total_price: raw.total_price, total_discount: raw.total_discount, note: raw.note, attributes: raw.attributes,
      items: raw.items.map(function (item) { return { key: item.key, variant_id: item.variant_id, product_id: item.product_id, sku: item.sku, quantity: item.quantity, properties: item.properties || {}, final_price: item.final_price, original_price: item.original_price }; }) };
  }
  function empty(model) { return !model.items.length && !model.note && !Object.keys(model.attributes).length; }
  function incomingMetadata(value) {
    var result = { id: value.id, key: value.key, phase: value.phase };
    if (value.copyAttempted === true) result.copyAttempted = true;
    if (HEX.test(value.fingerprint || '')) result.fingerprint = value.fingerprint;
    if (Number.isFinite(value.expiresAt)) result.expiresAt = value.expiresAt;
    return result;
  }
  function install(win) {
    var fence = win.NLCartTransferFence, running = false;
    function core() { if (!win.NLLanguageCartRelayCore) throw new Error('Basket transfer unavailable'); return win.NLLanguageCartRelayCore; }
    function storageCheck() {
      if (!fence) throw new Error('Basket fence unavailable'); fence.usable();
      win.sessionStorage.setItem(INCOMING + '-probe', '1');
      if (win.sessionStorage.getItem(INCOMING + '-probe') !== '1') throw new Error('Basket recovery storage unavailable');
      win.sessionStorage.removeItem(INCOMING + '-probe');
    }
    function store(key, value) { win.sessionStorage.setItem(key, JSON.stringify(key === INCOMING ? incomingMetadata(value) : value)); }
    function load(key) { var value = win.sessionStorage.getItem(key); return value ? JSON.parse(value) : null; }
    function adapter(id) { return core().createBrowserAdapter(win, { writeEnabled: true, transferId: id }); }
    function alive(record) { return record.expiresAt > Date.now() && fence.alive(record.id); }
    function requireAlive(record) { if (!alive(record)) throw new Error('Basket transfer expired; recovery required'); return true; }
    async function digest(value) {
      var bytes = new win.TextEncoder().encode(value);
      var hash = await win.crypto.subtle.digest('SHA-256', bytes);
      return Array.from(new Uint8Array(hash)).map(function (n) { return n.toString(16).padStart(2, '0'); }).join('');
    }
    async function api(action, body) {
      var abort = new win.AbortController(), timer = win.setTimeout(function () { abort.abort(); }, 8000);
      try {
        var response = await win.fetch(BASE + action, { method: 'POST', credentials: 'omit', redirect: 'error', cache: 'no-store', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body), signal: abort.signal });
        if (!response.ok || response.redirected) { var failure = new Error('Basket transfer could not be verified'); failure.status = response.status; throw failure; }
        var data = await response.json(); if (!data || data.ok !== true) throw new Error('Basket transfer could not be verified');
        return data;
      } finally { win.clearTimeout(timer); }
    }
    function validateMetadata(record, id) {
      if (record.id !== undefined && record.id !== id || !HEX.test(id) || !HEX.test(record.fingerprint) || !Number.isFinite(record.expiresAt) || record.expiresAt <= Date.now()) throw new Error('Basket receipt expired or invalid');
      if (!ORIGINS.includes(record.sourceOrigin) || !ORIGINS.includes(record.targetOrigin) || record.sourceOrigin === record.targetOrigin) throw new Error('Basket receipt origin mismatch');
      path(record.sourcePath); path(record.targetPath);
    }
    async function validateRecord(record, id) {
      validateMetadata(record, id);
      if (typeof record.modelJSON !== 'string' || new win.TextEncoder().encode(record.modelJSON).length > 200000 || await digest(record.modelJSON) !== record.fingerprint) throw new Error('Basket snapshot mismatch');
      var model = core().validate(JSON.parse(record.modelJSON));
      if (core().fingerprint(model) !== record.modelJSON || !model.items.length) throw new Error('Basket snapshot mismatch');
      return model;
    }
    async function phase(record, key, action) {
      requireAlive(record);
      var receipt = await api('phase', { id: record.id, key: key, action: action, fingerprint: record.fingerprint });
      if (receipt.fingerprint !== record.fingerprint || receipt.expiresAt !== record.expiresAt) throw new Error('Basket phase receipt mismatch');
      return receipt;
    }
    function navigate(origin, pathname, id, key, state) {
      path(pathname); if (!ORIGINS.includes(origin) || !HEX.test(id) || state !== 'source' && !HEX.test(key)) throw new Error('Basket destination invalid');
      var theme = win.Shopify && win.Shopify.theme;
      var preview = theme && ['unpublished', 'development'].includes(theme.role) && Number.isSafeInteger(theme.id) ? '?preview_theme_id=' + theme.id : '';
      win.location.assign(origin + pathname + preview + '#nl-transfer=' + id + (state === 'source' ? '.source' : '.' + key + '.' + state));
    }
    async function move(_raw, destination) {
      if (running) throw new Error('Another basket transfer is active'); running = true;
      var id, created = null, ownsLease = false;
      try {
        storageCheck(); await collectCompletedSource();
        if (fence.busy()) throw new Error('Another basket transfer is pending');
        var target = targetURL(destination, win.location.origin); path(win.location.pathname);
        var bytes = new Uint8Array(32); win.crypto.getRandomValues(bytes);
        id = Array.from(bytes).map(function (n) { return n.toString(16).padStart(2, '0'); }).join('');
        var cart = adapter(id), restore = cart.busy();
        try {
          await cart.settleNotes();
          await cart.withLock(async function () {
            fence.claim(id, Date.now() + 180000); ownsLease = true;
            var root = win.Shopify && win.Shopify.routes && win.Shopify.routes.root;
            if (typeof root !== 'string') throw new Error('Basket route unavailable');
            var url = new URL(root + 'cart.js', win.location.origin);
            var response = await fence.ownerFetch(id, url.href, { credentials: 'same-origin', redirect: 'error', cache: 'no-store', headers: { Accept: 'application/json' } });
            if (!response.ok || response.redirected || response.url !== url.href) throw new Error('Basket snapshot unavailable');
            var raw = await response.json(), model = cart.normalize(raw);
            if (!model.items.length) throw new Error('No basket transfer needed');
            var safeOriginal = original(raw);
            if (core().fingerprint(cart.normalize(safeOriginal)) !== core().fingerprint(model)) throw new Error('Basket recovery snapshot mismatch');
            var modelJSON = core().fingerprint(model);
            created = await api('create', { id: id, sourceOrigin: win.location.origin, targetOrigin: target.origin, sourcePath: path(win.location.pathname), targetPath: path(target.pathname), modelJSON: modelJSON });
            if (created.id !== id || created.state !== 'PREPARED' || !HEX.test(created.sourceKey) || !HEX.test(created.targetKey) || created.sourceKey === created.targetKey || created.fingerprint !== await digest(modelJSON)) throw new Error('Basket transfer receipt mismatch');
            fence.claim(id, created.expiresAt);
            var recovery = { id: id, sourceKey: created.sourceKey, targetKey: created.targetKey, original: safeOriginal, modelJSON: modelJSON, fingerprint: created.fingerprint, expiresAt: created.expiresAt, sourceOrigin: win.location.origin, sourcePath: win.location.pathname, targetOrigin: target.origin, targetPath: target.pathname, cleanupAttempted: false };
            store(SOURCE + id, recovery); win.sessionStorage.setItem(ACTIVE, id);
            requireAlive(recovery); await cart.assertNoPending();
            navigate(target.origin, target.pathname, id, created.targetKey, 'target');
          });
        } finally { restore(); }
      } catch (error) {
        // Before navigation the source was never modified. Abort only known
        // pre-cleanup records, never issue a compensating cart mutation.
        if (created && HEX.test(created.sourceKey)) {
          try { await api('phase', { id: id, key: created.sourceKey, action: 'abort', fingerprint: created.fingerprint }); } catch (_) {}
        }
        if (ownsLease) { try { await cart.withLock(async function () { fence.release(id); }); } catch (_) {} }
        throw error;
      } finally { running = false; }
    }
    function pointAddress(value) {
      if (!value || typeof value.address1 !== 'string' || !value.address1 || value.address1.length > 1000 || typeof value.city !== 'string' || !value.city || value.city.length > 1000 || value.countryCode !== 'CZ') return null;
      if (value.address2 !== undefined && (typeof value.address2 !== 'string' || value.address2.length > 1000) || value.zip !== undefined && (typeof value.zip !== 'string' || value.zip.length > 50)) return null;
      return { address1: value.address1, address2: value.address2 || undefined, city: value.city, zip: value.zip || undefined, countryCode: 'CZ' };
    }
    function selectedAddress(model) {
      if (model.attributes.globe_DeliveryMethod !== 'pickup') return null;
      var point = JSON.parse(model.attributes.globe_PickupPointData), address = point.addressObject;
      var result = pointAddress({ address1: address.street, address2: address.address2 || undefined, city: address.city, zip: address.zip || undefined, countryCode: 'CZ' });
      if (!result) throw new Error('Pickup address is incomplete'); return result;
    }
    async function syncPrefill(record, cart, expectedJSON, address, clear) {
      if (!address) return;
      requireAlive(record);
      var root = win.Shopify && win.Shopify.routes && win.Shopify.routes.root;
      if (typeof root !== 'string') throw new Error('Basket route unavailable');
      var rawURL = new URL(root + 'cart.js', win.location.origin).href;
      var abort = new win.AbortController(), timer = win.setTimeout(function () { abort.abort(); }, 8000);
      try {
        var response = await fence.ownerFetch(record.id, rawURL, { credentials: 'same-origin', redirect: 'error', cache: 'no-store', signal: abort.signal, headers: { Accept: 'application/json' } });
        if (!response.ok || response.redirected || response.url !== rawURL) throw new Error('Fresh basket unavailable');
        // The CartAjax token exists only in this function's browser memory.
        // It never enters the relay, a URL, recovery storage or diagnostics.
        var raw = await response.json();
        if (core().fingerprint(cart.normalize(raw)) !== expectedJSON || typeof raw.token !== 'string' || !raw.token || raw.token.length > 1000) throw new Error('Fresh basket identity mismatch');
        var body = clear ? { cartToken: raw.token, clear: true, clearAddress: address } : { cartToken: raw.token, buyer: { phone: raw.attributes.customer_phone || undefined, countryCode: 'CZ' }, address: address };
        var endpoint = win.location.origin + '/apps/appfleece-globe/checkout-prefill';
        var written = await fence.ownerFetch(record.id, endpoint, { method: 'POST', credentials: 'same-origin', redirect: 'error', cache: 'no-store', signal: abort.signal, headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
        if (!written.ok || written.redirected || written.url !== endpoint || (await written.json()).ok !== true) throw new Error('Pickup checkout address was not verified');
        var after = core().validate(await cart.read());
        if (core().fingerprint(after) !== expectedJSON) throw new Error('Basket changed during pickup address verification');
        await cart.assertNoPending(); requireAlive(record);
      } finally { win.clearTimeout(timer); }
    }
    async function targetStep(incoming) {
      var cached = load(INCOMING);
      if (cached && cached.id === incoming.id) incoming = Object.assign({}, cached, incoming);
      var record = await api('target', { id: incoming.id, key: incoming.key }); record.id = incoming.id;
      var model;
      if (record.state === 'DONE' && incoming.phase === 'finish') validateMetadata(record, incoming.id);
      else model = await validateRecord(record, incoming.id);
      if (incoming.fingerprint && incoming.fingerprint !== record.fingerprint || incoming.expiresAt && incoming.expiresAt !== record.expiresAt) throw new Error('Basket metadata changed');
      incoming.fingerprint = record.fingerprint; incoming.expiresAt = record.expiresAt;
      if (record.targetOrigin !== win.location.origin || record.targetPath !== win.location.pathname) throw new Error('Basket destination mismatch');
      store(INCOMING, incoming);
      var cart = adapter(record.id);
      await cart.withLock(async function () {
        fence.claim(record.id, record.expiresAt); requireAlive(record);
        var current = core().validate(await cart.read());
        if (incoming.phase === 'finish') {
          if (!['SOURCE_MOVED', 'DONE'].includes(record.state) || await digest(core().fingerprint(current)) !== record.fingerprint) throw new Error('Final basket receipt mismatch');
          await cart.assertNoPending(); requireAlive(record);
          if (record.state !== 'DONE') {
            var address = selectedAddress(current), clear = false;
            if (!address) {
              try { address = pointAddress(JSON.parse(win.sessionStorage.getItem('globeLastPointAddr') || 'null')); } catch (_) { address = null; }
              clear = true;
            }
            await syncPrefill(record, cart, core().fingerprint(current), address, clear);
          }
          var finished = record.state === 'DONE' ? record : await phase(record, incoming.key, 'finish');
          if (finished.state !== 'DONE') throw new Error('Final basket receipt unavailable');
          fence.release(record.id); win.sessionStorage.removeItem(INCOMING); return;
        }
        if (!['PREPARED', 'TARGET_VERIFIED'].includes(record.state)) throw new Error('Basket transfer requires recovery');
        var decision = core().plan(model, current);
        if (decision === 'conflict') throw new Error('A different basket is already saved in this language');
        if (record.state === 'TARGET_VERIFIED' && decision !== 'identical') throw new Error('Verified basket changed');
        if (decision === 'copy') {
          if (incoming.copyAttempted) throw new Error('Destination write completion is uncertain; recovery required');
          incoming.copyAttempted = true; store(INCOMING, incoming);
          requireAlive(record); await cart.copy(model, current);
        }
        var fresh = core().validate(await cart.read());
        if (core().fingerprint(fresh) !== record.modelJSON) throw new Error('Destination basket readback mismatch');
        await cart.assertNoPending(); requireAlive(record);
        var verified = await phase(record, incoming.key, 'targetVerified');
        if (verified.state !== 'TARGET_VERIFIED') throw new Error('Destination receipt unavailable');
        navigate(record.sourceOrigin, record.sourcePath, record.id, null, 'source');
      });
    }
    async function sourceStep(incoming) {
      var recovery = load(SOURCE + incoming.id);
      if (!recovery || recovery.id !== incoming.id || !HEX.test(recovery.sourceKey) || !HEX.test(recovery.targetKey)) throw new Error('Original basket recovery is unavailable');
      var record = await api('source', { id: recovery.id, key: recovery.sourceKey }); record.id = recovery.id;
      var model = await validateRecord(record, recovery.id);
      if (record.sourceOrigin !== win.location.origin || record.sourcePath !== win.location.pathname || record.modelJSON !== recovery.modelJSON || record.fingerprint !== recovery.fingerprint || record.targetOrigin !== recovery.targetOrigin || record.targetPath !== recovery.targetPath || record.expiresAt !== recovery.expiresAt) throw new Error('Original basket receipt mismatch');
      var cart = adapter(record.id);
      await cart.withLock(async function () {
        fence.claim(record.id, record.expiresAt); requireAlive(record);
        if (record.state === 'TARGET_VERIFIED' && !recovery.cleanupAttempted) {
          // Exact full source and line-key CAS is enforced inside removeOriginal.
          var started = await phase(record, recovery.sourceKey, 'cleanupStart');
          if (started.state !== 'CLEANING') throw new Error('Source receipt unavailable');
          recovery.cleanupAttempted = true; store(SOURCE + record.id, recovery);
          await cart.removeOriginal(model, recovery.original, function () { return alive(record); });
        } else if (!['CLEANING', 'SOURCE_MOVED'].includes(record.state)) throw new Error('Source cleanup cannot be repeated');
        // Recovery never retries an uncertain POST. It can only attest an
        // already-empty first-party source, then complete the receipt.
        var after = core().validate(await cart.read());
        if (!empty(after)) throw new Error('Original basket is still saved; manual recovery required');
        await cart.assertNoPending(); requireAlive(record);
        if (record.state !== 'SOURCE_MOVED') {
          await syncPrefill(record, cart, core().fingerprint(after), selectedAddress(model), true);
          var moved = await phase(record, recovery.sourceKey, 'sourceMoved');
          if (moved.state !== 'SOURCE_MOVED') throw new Error('Source completion receipt unavailable');
        }
        recovery.sourceMovedConfirmed = true; store(SOURCE + record.id, recovery);
        fence.release(record.id); win.sessionStorage.removeItem(INCOMING);
        navigate(record.targetOrigin, record.targetPath, record.id, recovery.targetKey, 'finish');
      });
    }
    async function resume(incoming) {
      if (running) throw new Error('Another basket transfer is active'); running = true;
      try {
        storageCheck(); if (!incoming || incoming.invalid || !HEX.test(incoming.id)) throw new Error('Invalid basket transfer link');
        if (incoming.phase === 'source') { store(INCOMING, incoming); return await sourceStep(incoming); }
        if (!['target', 'finish'].includes(incoming.phase) || !HEX.test(incoming.key)) throw new Error('Invalid basket transfer link');
        return await targetStep(incoming);
      } catch (error) {
        if (incoming && incoming.phase === 'source') {
          var saved = load(SOURCE + incoming.id);
          if (saved) await quarantineSource(incoming.id, saved, 'source-resume-unverified');
        }
        fence.showError(); throw error;
      }
      finally { running = false; }
    }
    async function quarantineSource(id, saved, reason) {
      // Never discard the only original snapshot or cleanup intent merely
      // because the RAM service expired or its state cannot be established.
      saved.quarantined = true; saved.quarantineReason = reason;
      store(SOURCE + id, saved);
      try {
        await adapter(id).withLock(async function () { fence.quarantine(id, saved.expiresAt); });
      } catch (_) { /* A different lease remains authoritative, preserve both. */ }
      fence.showError();
    }
    async function collectConfirmedMovedSource(id, saved) {
      // An acknowledged sourceMoved follows an exact empty source readback.
      // Once its lease is released there is no uncertain source write left.
      // RAM expiry may then discard only this explicitly confirmed recovery.
      if (saved.sourceMovedConfirmed !== true || fence.busy()) return false;
      var collected = false;
      await adapter(id).withLock(async function () {
        var current = load(SOURCE + id);
        if (!fence.busy() && current && current.sourceMovedConfirmed === true && current.fingerprint === saved.fingerprint && current.sourceKey === saved.sourceKey) {
          win.sessionStorage.removeItem(SOURCE + id); win.sessionStorage.removeItem(ACTIVE); collected = true;
        }
      });
      return collected;
    }
    async function collectCompletedSource() {
      var id = win.sessionStorage.getItem(ACTIVE); if (!id || !HEX.test(id)) return;
      var saved = load(SOURCE + id); if (!saved) return;
      if (saved.expiresAt <= Date.now()) {
        if (await collectConfirmedMovedSource(id, saved)) return;
        await quarantineSource(id, saved, 'expired-unknown'); return;
      }
      try {
        var record = await api('source', { id: id, key: saved.sourceKey });
        if (record.state === 'DONE' && record.fingerprint === saved.fingerprint && record.expiresAt === saved.expiresAt) {
          await adapter(id).withLock(async function () {
            if (fence.busy()) fence.release(id);
            win.sessionStorage.removeItem(SOURCE + id); win.sessionStorage.removeItem(ACTIVE);
          });
        } else await quarantineSource(id, saved, 'nonterminal-unknown');
      } catch (error) {
        if (error.status === 410 && await collectConfirmedMovedSource(id, saved)) return;
        await quarantineSource(id, saved, 'unavailable-unknown');
      }
    }
    var incoming = fence && fence.incoming();
    if (!incoming && fence && fence.busy()) { try { incoming = load(INCOMING); } catch (_) {} }
    var ready = Promise.resolve();
    function boot() { ready = incoming ? resume(incoming) : collectCompletedSource(); ready.catch(function () { if (fence && fence.busy()) fence.showError(); }); }
    if (win.document.readyState === 'loading' || win.document.readyState === 'interactive') win.document.addEventListener('DOMContentLoaded', boot, { once: true }); else win.setTimeout(boot, 0);
    return { move: move, resume: resume, whenReady: function () { return ready; }, collectCompletedSource: collectCompletedSource };
  }
  return { install: install, sanitizeOriginal: original, targetURL: targetURL, validPath: path, isSemanticEmpty: empty };
});
